export abstract class NpPagingUtils {

    static getStartIdx(pageIdx: number, pageSize: number): number {
        // return pageIdx < 1 ? 0 : pageSize * pageIdx;
        return pageSize * pageIdx;
    }

    static getPageCount(totalItemCount: number, pageSize: number): number {

        /**
         * 전체 아이템 수가 없거나 페이지 사이즈가 없다면 전체 페이지는 1개
         * 전체 아이템 수가 페이지 사이즈보다 작거나 같다면 페이지는 1개
         */
        if (totalItemCount === 0 || pageSize === 0 || totalItemCount <= pageSize) {
            return 1;
        } else {
            return Math.trunc(totalItemCount / pageSize) + 1;
        }

    }

    // static getPageIdx(startIdx: number, totalItemCount: number, pageSize: number): number {
    //     // 검색하려는 recored의 시작 번호가 전체 아이템 수 보다 높다면 에러
    //     if ((totalItemCount - 1) < startIdx) {
    //         throw new Error("startIdx가 totalItemIdx 보다 높습니다.");
    //     }
    //     /**
    //      * 가능한 페이지 수를 구한다.
    //      */
    //     const pageCount = NpPagingUtils.getPageCount(totalItemCount, pageSize);
    //     // 페이지가 1개인 경우 0 리턴
    //     // 시작 idx가 pageSize보다 작으면 0리턴
    //     if (pageCount === 1 || (pageSize > startIdx)) {
    //         return 0;
    //     } else {
    //         const pageIdx = Math.trunc(startIdx / pageSize);
    //         if (pageCount < pageIdx + 1) {
    //             throw new Error("pageIdx가 가능 범위를 벗어났습니다.");
    //         }
    //         return pageIdx;
    //     }
    // }

    static getPageIdx(startIdx: number, pageSize: number): number {

        // 페이지가 1개인 경우 0 리턴
        // 시작 idx가 pageSize보다 작으면 0리턴
        if ((pageSize > startIdx)) {
            return 0;
        } else {
            const pageIdx = Math.trunc(startIdx / pageSize);
            return pageIdx;
        }

    }

}